module.exports = __webpack_public_path__ + "img/BOA.c6c8ae25.png";